export default __webpack_public_path__ + "static/media/atram.43906282.png";